export default __webpack_public_path__ + "static/media/symphony.749180ad.png";